// import { showAlert, hideAlert } from './alert';
import { apiClient } from '../../utils';
import { uploadMedia, handleError } from '../';

export const createCampaign = async ({
  site,
  name,
  link_web,
  link_app,
  media,
  pt,
}) => {
  try {
    // link_app
    const data = { site, name, link_web, positionType: pt };
    const cmp = await apiClient.post('/merchant/campaign/create', { data });
    const campaignID = cmp?.result?._id;
    const mediaPayload = { site, mc: name, campaign: media, campaignID };
    await uploadMedia(mediaPayload, { endpoint: '/merchant/media/upload' });

    return cmp.result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
